// src/app/features/questionnaires/index.tsx
import { DashboardContainerHeader } from 'app/layout/dashboardLayout/BoxLayout';
import { AddIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import { useNavigate } from 'react-router-dom';
import useMediaQueries from '../../hooks/useMediaQueries';
import QuestionnairesTable from './list/QuestionnairesTable';
export interface IQuestionnairesProps {}

export default function Questionnaires(props: IQuestionnairesProps) {
  const { md_down: isMobile } = useMediaQueries();
  const navigate = useNavigate();

  return (
    <>
      <DashboardContainerHeader title="Tax Returns">
        <CustomButton
          text={isMobile ? ' New' : ' New Questionnaire'}
          borderColor="green"
          bgColor="white"
          textColor="green"
          height="10"
          textSize="text-xs"
          width="max-w-min whitespace-nowrap"
          prefix={<AddIcon />}
          onClick={() => navigate('/dashboard/questionnaires/create')}
        />
      </DashboardContainerHeader>

      <QuestionnairesTable />
    </>
  );
}
